<div class="confirmation-banner-overlay">
  <div class="confirmation-banner-container">
    <div class="banner-content">
      <div class="banner-icon">
        <!-- <img [src]="IMAGE_URL + \"/icons/warning 1.png\"" alt="Warning" class="warning-icon" /> -->
      </div>
      <div class="banner-text">
        <h3 class="banner-title">Heads up!</h3>
        <p class="banner-message">{{ message }}</p>
      </div>
      <div class="banner-actions">
        <button class="banner-btn cancel-btn" (click)="onCancel()">
          <span>Cancel</span>
        </button>
        <button class="banner-btn continue-btn" (click)="onContinue()">
          <span>Continue</span>
          <!-- <img [src]="IMAGE_URL + \"/icons/WhiteLineArrow.png\"" width="20" alt="Arrow" /> -->
        </button>
      </div>
    </div>
    <div class="banner-progress">
      <div class="progress-bar"></div>
    </div>
  </div>
</div>
